// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { EzSelectorList, postEzSelectorLines } from "@ces/App/Services/xEzSelector";
import {
    ApiHandler,
    createHandlerChainRunner,
    HasOnSuccess,
    makeHandlerChainAwaitable,
} from "@insite/client-framework/HandlerCreator";
import addCartLineCollectionFromProducts from "@insite/client-framework/Store/Pages/OrderUpload/Handlers/AddCartLineCollectionFromProducts";
import { CartLineModel } from "@insite/client-framework/Types/ApiModels";

type HandlerType = ApiHandler<{ products: EzSelectorList } & HasOnSuccess, { lines: CartLineModel[] }>;

export const PopulateApiParameters: HandlerType = props => {
    props.apiParameter = { ...props.parameter };
};

export const RequestDataFromApi: HandlerType = async props => {
    try {
        props.apiResult = await postEzSelectorLines(props.apiParameter.products);
    } catch (error) {
        props.apiResult = { lines: [] };
    }
};
export const AddToCart: HandlerType = async props => {
    if (!props.apiResult?.lines?.length) {
        return;
    }
    const awaitableAddToCart = makeHandlerChainAwaitable(addCartLineCollectionFromProducts);
    try {
        await awaitableAddToCart({
            products: props.apiResult.lines.map(({ productId, ...rest }) => ({ ...rest, id: productId || "" })) as any,
        })(props.dispatch, props.getState);
    } catch (error) {
        props.apiResult = { lines: [] };
    }
};
export const DispatchCompleteLoadFeaturedCategoriesData: HandlerType = props => {
    props.parameter.onSuccess?.(props.apiResult.lines as any);
};

export const chain = [PopulateApiParameters, RequestDataFromApi, AddToCart, DispatchCompleteLoadFeaturedCategoriesData];

const ezSelectorAddProducts = createHandlerChainRunner(chain, "ezSelectorAddProducts");

export default ezSelectorAddProducts;
